import { Image } from '@tracsis/library/src';
import { ThemeContext } from '@tracsis/library/src/context/ThemeContext';
import cx from 'classnames';
import { GatsbyImageProps, getImage } from 'gatsby-plugin-image';
import React, { useContext } from 'react';

import { Quote as QuoteIcon } from '../Icon';
import * as styles from './QuoteBreaker.module.css';

const QuoteBreaker = ({
	children,
}: {
	children:
		| React.ReactElement
		| React.ReactElement[]
		| JSX.Element
		| JSX.Element[];
	variant: 'standard' | 'altaccent';
}) => {
	const { variant } = useContext(ThemeContext);

	return (
		<div className={cx(styles.breaker, styles[variant])}>
			<div className={styles.accent}></div>
			<div className={styles.box}>
				<div className={styles.icon}>
					<QuoteIcon />
				</div>
				<blockquote className={styles.content}>{children}</blockquote>
			</div>
		</div>
	);
};

const Quote = ({
	children,
}: {
	children:
		| React.ReactElement
		| React.ReactElement[]
		| JSX.Element
		| JSX.Element[];
}) => children;

const Citation = ({
	children,
	image,
	alt,
}: {
	children:
		| React.ReactElement
		| React.ReactElement[]
		| JSX.Element
		| JSX.Element[]
		| string;
	image: GatsbyImageProps | string;
	alt: string;
}) => (
	<footer className={styles.footer}>
		{image && (
			<div className={styles.authorPhoto}>
				<Image image={getImage(image)} alt={alt} />
			</div>
		)}
		<cite>{children}</cite>
	</footer>
);

QuoteBreaker.Quote = Quote;
QuoteBreaker.Citation = Citation;

export default QuoteBreaker;
